export default __webpack_public_path__ + "static/media/pic10.1268c49b.jpg";